/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeBlockFormats.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Block Format Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Wednesday, November 14, 2018 - 12:17:52 AM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      11/14/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const BLOCKFORMAT_LIST_CONTAINER_LOADED = 'BLOCKFORMAT_LIST_CONTAINER_LOADED';
export const BLOCKFORMAT_LIST_CONTAINER_UNLOADED = 'BLOCKFORMAT_LIST_CONTAINER_UNLOADED';
export const BLOCKFORMAT_LIST_TABLE_LOADED = 'BLOCKFORMAT_LIST_TABLE_LOADED';
export const BLOCKFORMAT_LIST_TABLE_UNLOADED = 'BLOCKFORMAT_LIST_TABLE_UNLOADED';

export const BLOCKFORMAT_SELECT_ROW = 'BLOCKFORMAT_SELECT_ROW';

export const BLOCKFORMAT_ADD = 'BLOCKFORMAT_ADD';
export const BLOCKFORMAT_EDIT = 'BLOCKFORMAT_EDIT';
export const BLOCKFORMAT_DELETE = 'BLOCKFORMAT_DELETE';
export const BLOCKFORMAT_OPEN_WARNING = 'BLOCKFORMAT_OPEN_WARNING';
export const BLOCKFORMAT_CLOSE_WARNING = 'BLOCKFORMAT_CLOSE_WARNING';
export const BLOCKFORMAT_DELETE_DISABLE = 'BLOCKFORMAT_DELETE_DISABLE';
export const BLOCKFORMAT_VIEW_CHILD_ITEMS = 'BLOCKFORMAT_VIEW_CHILD_ITEMS';

export const BLOCKFORMAT_EDIT_CONTAINER_LOADED = 'BLOCKFORMAT_EDIT_CONTAINER_LOADED';
export const BLOCKFORMAT_EDIT_CONTAINER_UNLOADED = 'BLOCKFORMAT_EDIT_CONTAINER_UNLOADED';
export const BLOCKFORMAT_EDIT_FORM_LOADED = 'BLOCKFORMAT_EDIT_FORM_LOADED';
export const BLOCKFORMAT_EDIT_FORM_UNLOADED = 'BLOCKFORMAT_EDIT_FORM_UNLOADED';

export const BLOCKFORMAT_EDIT_DATA_LOAD = 'BLOCKFORMAT_EDIT_DATA_LOAD';

export const BLOCKFORMAT_EDIT_CONTAINER_SUBMIT = 'BLOCKFORMAT_EDIT_CONTAINER_SUBMIT';
export const BLOCKFORMAT_EDIT_CONTAINER_CANCEL = 'BLOCKFORMAT_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeBlockFormats.js